import { io } from "socket.io-client";

// Simple global event emitter for socket events
export const socketEvents = {
  listeners: {},
  on(event, fn) {
    if (!this.listeners[event]) this.listeners[event] = [];
    this.listeners[event].push(fn);
  },
  off(event, fn) {
    if (!this.listeners[event]) return;
    this.listeners[event] = this.listeners[event].filter(f => f !== fn);
  },
  emit(event, ...args) {
    if (!this.listeners[event]) return;
    this.listeners[event].forEach(fn => fn(...args));
  }
};

/* =========================================================
   CONFIG
========================================================= */

export const SERVER_URL =
  process.env.REACT_APP_SERVER_URL ||
  (process.env.NODE_ENV === "development"
    ? "http://localhost:5001"
    : window.location.origin);

export const AUTH_STORAGE_KEY = "chatAuth";

let socket = null;

const createSocket = (token) => {

 const instance = io(SERVER_URL, {
  auth: token ? { token } : {},
  transports: ["websocket"],
  withCredentials: true,
  reconnection: true,
  reconnectionAttempts: Infinity,
  reconnectionDelay: 2000,
  timeout: 20000
});

instance.io.on("reconnect", () => {

   socketEvents.emit("reconnect");

});
  /* ================= CONNECT ================= */

  instance.on("connect", () => {

    console.log("✅ Socket connected:", instance.id);

    try {

      const raw = localStorage.getItem(AUTH_STORAGE_KEY);
      const parsed = raw ? JSON.parse(raw) : null;
      const email = parsed?.user?.email;

      if (email) {
        instance.emit("join", email);
        //console.log("✅ Joined room:", email);
      }

    } catch (e) {
      console.error("Join error:", e);
    }

  });
  

  instance.io.on("reconnect", () => {
    console.log("🔄 Socket reconnected");
    try {
      const raw = localStorage.getItem(AUTH_STORAGE_KEY);
      const parsed = raw ? JSON.parse(raw) : null;
      const email = parsed?.user?.email;
      if (email) {
        instance.emit("join", email);
        console.log("✅ Rejoined room:", email);
      }
    } catch {}
    // Emit global reconnect event
    socketEvents.emit("reconnect");
  });
  instance.on("disconnect", (reason) => {
    console.warn("⚠️ Socket disconnected:", reason);
  });

  instance.on("connect_error", (err) => {
    console.error("❌ Socket error:", err?.message);
  });

  /* =========================================================
     MAIL EVENTS
  ========================================================== */

  const mailHandler = (payload) => {

    window.dispatchEvent(
      new CustomEvent("mail-received", { detail: payload })
    );

  };

  const mailUpdatedHandler = (payload) => {

    window.dispatchEvent(
      new CustomEvent("mail-updated", { detail: payload })
    );

  };

  instance.on("mail_received", mailHandler);
  instance.on("mail_updated", mailUpdatedHandler);

  /* =========================================================
     CHAT EVENTS
  ========================================================== */

  const chatHandler = (payload) => {

    window.dispatchEvent(
      new CustomEvent("chat-received", { detail: payload })
    );

  };

  instance.on("chat_message", chatHandler);

  /* =========================================================
     GROUP EVENTS
  ========================================================== */

  const groupDeletedHandler = (payload) => {

    window.dispatchEvent(
      new CustomEvent("group-deleted", { detail: payload })
    );

  };

  instance.on("group_deleted", groupDeletedHandler);

  instance.__dispose = () => {

    instance.off("mail_received", mailHandler);
    instance.off("mail_updated", mailUpdatedHandler);
    instance.off("chat_message", chatHandler);
    instance.off("group_deleted", groupDeletedHandler);
  
    //instance.removeAllListeners();
  
    
  };

  return instance;
};

/* =========================================================
   CONNECT SOCKET (Singleton)
========================================================= */

export const connectSocket = () => {

  if (!socket) {

    let token = null;

    try {

      const raw = localStorage.getItem(AUTH_STORAGE_KEY);
      const parsed = raw ? JSON.parse(raw) : null;
      token = parsed?.token;

    } catch (e) {
      console.error("Token read error:", e);
    }

    if (!token) {
      console.info("[Socket] No auth token available; skipping socket connection");
      return null;
    }

    socket = createSocket(token);

  }

  return socket;
};

/* =========================================================
   DISCONNECT SOCKET
========================================================= */

export const disconnectSocket = () => {

  if (socket) {

    if (typeof socket.__dispose === "function") {
      socket.__dispose();
    }

    socket.disconnect();
    socket = null;

    console.log("🔌 Socket disconnected manually");

  }

};

/* =========================================================
   LOGOUT
========================================================= */

export function clearAuthAndRedirect() {

  try {
    localStorage.removeItem(AUTH_STORAGE_KEY);
  } catch {}

  disconnectSocket();

  window.location.href = "/login";

}